import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  actions,
  sendFeedbackSuccess,
  openFeedbackModal,
  SEND_FEEDBACK,
  sendFeedbackFailure,
} from 'spw-redux/modules/feedback/actions';
import { userFeedback } from 'spw-api';
import { APIResponse } from 'spw-redux/types';
import { isNil } from 'ramda';
import { getBrowserInfo } from 'spw-shared/utils';
import { handleError } from 'spw-redux/modules/UI/messages/actions';
import { IFeedback, IDeviceInfo } from './types';

function* sendFeedback(action: ReturnType<typeof actions.sendFeedback>) {
  try {
    const { subject, description, attachment } = action.payload;
    const browser = getBrowserInfo();
    const feedback: IFeedback = {
      body: description,
      subject,
    };
    const device: IDeviceInfo = {
      platform: 'web',
      browser,
    };
    const screenshots = isNil(attachment) ? [] : [attachment];
    const response: APIResponse<typeof userFeedback> = yield call(
      userFeedback,
      feedback,
      device,
      screenshots
    );
    const { status } = response.data?.userFeedback;

    if (status === 'sent') {
      yield put(openFeedbackModal(false));
      yield put(sendFeedbackSuccess());
    }
  } catch (e) {
    yield put(handleError(e));
    yield put(sendFeedbackFailure());
  }
}

function* saga() {
  yield all([takeLatest(SEND_FEEDBACK, sendFeedback)]);
}

export default saga;
